import { HorizontalScroller } from "@Components/game/common/horizontal-scroller";
import { BybStepper } from "@Components/game/common/styled-components";
import { PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";
import { Box, Skeleton, Stack, SxProps, useTheme } from "@mui/material";
import { useState } from "react";
import "swiper/css";
import { SwiperSlide } from "swiper/react";
import PlaylistCardLarge from "./cards/playlist-card-large";

interface IPlaylistRowLarge {
  playlists?: PlaylistResponse[];
  loading?: boolean;
  sx?: SxProps;
}

const PlaylistRowLarge = ({ playlists, loading, sx }: IPlaylistRowLarge) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const maxSteps = playlists?.length || 0;
  return !loading ? (
    <Stack sx={{ position: "relative", ...sx }}>
      <HorizontalScroller
        padding={theme.spacing(6)}
        slidesPerGroup={1}
        freeMode={{ enabled: false }}
        navigation={false}
        onSlideChange={(swiper) => setActiveStep(swiper.realIndex)}
      >
        {playlists!.map((playlist: PlaylistResponse) => (
          <SwiperSlide
            key={playlist.id}
            style={{ cursor: "grab", height: "auto", width: `calc(100% - ${theme.spacing(6)})`, margin: theme.spacing(6) }}
          >
            <PlaylistCardLarge playlist={playlist} />
          </SwiperSlide>
        ))}
      </HorizontalScroller>
      <Box>
        {maxSteps > 1 && (
          <BybStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={null}
            backButton={null}
            sx={{ marginBottom: theme.spacing(6) }}
          />
        )}
      </Box>
    </Stack>
  ) : (
    <Skeleton variant="rounded" height={512} width="100%" sx={{ borderRadius: theme.spacing(3) }} />
  );
};

export default PlaylistRowLarge;
